<template>
    <div class="user-profile-expanded">
        <div class="content">
            <div class="avatar">
                <img
                    class="avatar-thumbnail"
                    :src="profileAvatar" />
                <avatar-cropper
                    v-if="$authUser.isStudent()"
                    :labels="labels"
                    trigger="#pick-avatar"
                    upload-url="/profile/uploadavatar"
                    @error="handleError"
                    @uploaded="handleUploaded"
                    @uploading="handleUploading" />
            </div>

            <div class="user-credentials">
                <div class="name">
                    {{ userCredentialsIn.full_name ? userCredentialsIn.full_name : userCredentialsIn.name }}
                </div>

                <div class="email">
                    {{ userCredentialsIn.email }}
                </div>

                <div
                    class="actions"
                    v-if="$authUser.isStudent()">
                    <design-2021-custom-banner-upload-widget-component :banner-in="$authUser.profileBannerImage">
                    </design-2021-custom-banner-upload-widget-component>

                    <b-button
                        class="btn-camera-icon btn-custom-avatar"
                        id="pick-avatar"
                        variant="primary">
                        Profielfoto aanpassen
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AvatarCropper from 'vue-avatar-cropper';

export default {
    name: 'design-2021-user-profile-credentials-expanded-component',
    components: { AvatarCropper },
    props: {
        teacherAccess: {
            type: Boolean,
            default: () => {
                return false;
            },
        },

        userCredentialsIn: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            profileAvatar: this.userCredentialsIn.profile_image_thumb_path ?? '/images/default_avatar_profile.jpg',
            labels: { submit: 'Opslaan', cancel: 'Annuleren' },
        };
    },

    methods: {
        handleError(resp) {
            this.alert.ajaxError(error);
        },

        handleUploaded(resp) {
            this.profileAvatar = resp.image.file.path;
            this.alert.success('Foto opgeslagen', 'De nieuwe foto is opgeslagen.');
        },

        handleUploading() {
            this.alert.saving('Foto opslaan', 'De foto wordt opgeslagen, een moment geduld alsjeblieft.');
        },
    },
};
</script>

<style scoped lang="scss">
.user-profile-expanded {
    background-color: $white;
    border-top-left-radius: $border-radius-content;
    border-top-right-radius: $border-radius-content;
    margin-top: 80px;
}

.content {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}

.avatar {
    height: 100px;
    width: 100px;
    border-radius: 50%;
    overflow: hidden;
    border: 3px solid $primary;
    box-shadow: 0 0 0 0 rgba($black, 0.4);
    margin-bottom: map-get($grid-gutter-spacing, 'ten');
    margin-top: -50px;

    img {
        object-fit: cover;
        object-position: center;
        height: 100%;
        width: 100%;
    }
}

.name {
    font-size: 1.3125rem;
    font-weight: $font-weight-bold;
}

.email {
    color: $text-muted-color;
    font-weight: $font-weight-medium;
    font-size: 0.75rem;
}

.actions {
    margin-top: $grid-gutter-width;

    ::v-deep .btn {
        width: 100%;
    }

    .custom-banner-management {
        margin-left: 0;
        margin-bottom: map-get($grid-gutter-spacing, 'ten');
    }
}

.user-credentials {
    width: 100%;
    text-align: center;

    ::v-deep .btn-banner-upload {
        background-color: transparent;
        border: 1px solid $primary;
        color: $primary;
        justify-content: center;

        &:hover {
            background-color: $primary;
            color: $white;
        }
    }

    .btn {
        width: 100%;
        font-size: $default-font-size;

        &:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .content {
        column-gap: $grid-gutter-width;
    }

    .user-credentials {
        width: 400px;
    }

    .actions {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        column-gap: map-get($grid-gutter-spacing, 'fifteen');

        ::v-deep .btn {
            width: auto;

            &:not(:last-child) {
                margin-bottom: 0;
            }
        }

        .custom-banner-management {
            margin-bottom: 0;
        }
    }
}
</style>
